"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
Object.defineProperty(exports, "useLayoutEffect", {
  enumerable: true,
  get: function get() {
    return _react.useLayoutEffect;
  }
});
var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/typeof"));
var _react = require("react");
// Silences layout effect warnings during server side rendering. Required until
// the next React version is released and widely adopted.
// @see https://github.com/facebook/react/pull/26395
var _default = exports.default = (typeof document === "undefined" ? "undefined" : (0, _typeof2.default)(document)) === 'object' ? _react.useLayoutEffect : _react.useEffect;